<template>
  <v-form ref="form" class="row ml-0 mr-0">
    <v-text-field class="col-12 col-sm-6 col-lg-3"
                  v-model="searchData.ticket_number"
                  label="Numer karnetu"
    ></v-text-field>
    <v-text-field class="col-12 col-sm-6 col-lg-3"
                  v-model="searchData.ticket_person"
                  label="Imię i nazwisko"
    ></v-text-field>

    <v-text-field class="col-12 col-sm-6 col-lg-3"
                  v-model="searchData.invoice_number"
                  label="Numer paragonu / faktury"
    ></v-text-field>


    <div class="col-12 col-sm-6 col-lg-3">
      <v-autocomplete
          :items="statuses"
          label="Status"
          data-vv-name="status"
          v-model="searchData.status"
          item-text="name"
          item-value="value"
      ></v-autocomplete>
    </div>

    <v-menu class="col-6 col-lg-3"
            :close-on-content-click="false"
            v-model="created_fromPicker"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
    >
      <v-text-field
          label="Data wydania: od"
          slot="activator"
          v-model="searchData.created_from"
          browser-autocomplete="off"
          @input="searchData.created_from = null">
      </v-text-field>
      <v-date-picker v-model="searchData.created_from"
                     @input="created_fromPicker = false"
                     :max="searchData.created_to"></v-date-picker>
    </v-menu>

    <v-menu class="col-6 col-lg-3"
            :close-on-content-click="false"
            v-model="created_toPicker"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
    >
      <v-text-field
          label="Data wydania: do"
          slot="activator"
          v-model="searchData.created_to"
          browser-autocomplete="off"
          @input="searchData.created_to = null">
      </v-text-field>
      <v-date-picker v-model="searchData.created_to"
                     @input="created_toPicker = false"
                     :min="searchData.created_from"></v-date-picker>
    </v-menu>

    <div class="col-sm-6 col-lg-3" v-if="isAdmin">
      <v-autocomplete
          :items="userList"
          label="Pracownik"
          data-vv-name="pracownik"
          v-model="searchData.user_id"
      >
        <template
            slot="selection"
            slot-scope="data"
        >
          {{ data.item.name }} {{ data.item.surname }}
        </template>
        <template
            slot="item"
            slot-scope="{ item }"
        >
          <v-list-tile-content>
            <v-list-tile-title
                v-text="`${item.name} ${item.surname} ${markAsDeleted(item.deleted_at)}`"></v-list-tile-title>
          </v-list-tile-content>
        </template>
      </v-autocomplete>
    </div>
    <div class="col-12 col-sm-6 col-lg-3">
      <v-autocomplete
          :items="lockedItems"
          label="Zablokowane"
          data-vv-name="locked"
          v-model="searchData.locked"
          item-text="name"
          item-value="value"
      ></v-autocomplete>
    </div>
    <v-menu class="col-6 col-lg-3"
            :close-on-content-click="false"
            v-model="expiration_date_fromPicker"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
    >
      <v-text-field
          label="Data ważności: od"
          slot="activator"
          v-model="searchData.expiration_date_from"
          browser-autocomplete="off"
          @input="searchData.expiration_date_from = null">
      </v-text-field>
      <v-date-picker v-model="searchData.expiration_date_from"
                     @input="expiration_date_fromPicker = false"
                     :max="searchData.expiration_date_to"></v-date-picker>
    </v-menu>

    <v-menu class="col-6 col-lg-3"
            :close-on-content-click="false"
            v-model="expiration_date_toPicker"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
    >
      <v-text-field
          label="Data ważności: do"
          slot="activator"
          v-model="searchData.expiration_date_to"
          browser-autocomplete="off"
          @input="searchData.expiration_date_to = null">
      </v-text-field>
      <v-date-picker v-model="searchData.expiration_date_to"
                     @input="expiration_date_toPicker = false"
                     :min="searchData.expiration_date_from"></v-date-picker>
    </v-menu>
    <div class="display-flex w-100 justify-content-end">
      <v-btn class="mr-0" color="white" @click="$emit('search',true, searchData)">
        Szukaj
      </v-btn>
    </div>
  </v-form>
</template>

<script>
export default {
  name: 'TicketSearch',
  props: {
    typeList: Array,
    userList: Array,
    propsSearchData: Object,
  },
  data() {
    return {
      statuses: [
        {
          value: 'N',
          name: 'Nowe',
        },
        {
          value: 'I',
          name: 'W realizacji',
        },
        {
          value: 'F',
          name: 'Zakończone',
        },
      ],
      lockedItems: [
        {
          value: 'NULL',
          name: 'Wszystkie',
        },
        {
          value: '1',
          name: 'Zablokowane',
        },
        {
          value: '0',
          name: 'Nie zablokowane',
        },
      ],
      created_fromPicker: false,
      created_toPicker: false,
      expiration_date_fromPicker: false,
      expiration_date_toPicker: false,
      searchData: Object.assign({}, this.$props.propsSearchData),
    };
  },
  computed: {
    isAdmin() {
      return JSON.parse(localStorage.getItem('USERDATA')).type !== 'U';
    },
  },
  methods: {
    markAsDeleted(val) {
      return val ? '[Usunięty]' : '';
    },
  },
};
</script>

<style scoped>

</style>
